import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/logo2.png';
const _hoisted_1 = {
  class: "login-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "width": "50%",
    "margin": "10px auto"
  }
};
const _hoisted_3 = {
  style: {
    "text-align": "right"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createElementVNode("div", {
        class: "login_net"
      }, null, -1)]))]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form, {
        ref: "loginForm",
        model: $data.loginForm,
        class: "login-form",
        "auto-complete": "on",
        "label-position": "left",
        rules: $data.rules
      }, {
        default: _withCtx(() => [_cache[18] || (_cache[18] = _createElementVNode("div", {
          class: "title-container"
        }, [_createElementVNode("img", {
          src: _imports_0,
          style: {
            "width": "40px",
            "height": "40px"
          }
        }), _createElementVNode("h1", {
          class: "title"
        }, "特检通")], -1)), $data.loginType === 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          prop: "userName",
          style: {
            "width": "50%",
            "margin": "20px auto"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.loginForm.userName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.loginForm.userName = $event),
            placeholder: "用户名",
            name: "username",
            type: "text",
            tabindex: "1",
            "auto-complete": "on"
          }, {
            prepend: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createElementVNode("span", {
              class: "iconfont icon-jurassic_user",
              style: {
                "margin-right": "0px"
              }
            }, null, -1)]))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), $data.loginType === 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          prop: "passWord",
          style: {
            "width": "50%",
            "margin": "20px auto"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.loginForm.passWord,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.loginForm.passWord = $event),
            type: "password",
            placeholder: "密码",
            name: "password",
            tabindex: "2",
            "auto-complete": "on",
            "show-password": true
          }, {
            prepend: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createElementVNode("span", {
              class: "iconfont icon-suo",
              style: {
                "margin-right": "0px"
              }
            }, null, -1)]))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), $data.loginType === 'sms' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 2,
          prop: "phoneNumber",
          style: {
            "width": "50%",
            "margin": "20px auto"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.loginForm.phoneNumber,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.loginForm.phoneNumber = $event),
            placeholder: "手机号",
            name: "phoneNumber",
            type: "text",
            tabindex: "1",
            "auto-complete": "on"
          }, {
            prepend: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createElementVNode("span", {
              class: "iconfont icon-phone",
              style: {
                "margin-right": "0px"
              }
            }, null, -1)]))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), $data.loginType === 'sms' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 3,
          prop: "captcha",
          style: {
            "width": "50%",
            "margin": "20px auto"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.loginForm.captcha,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.loginForm.captcha = $event),
            placeholder: "验证码",
            name: "captcha",
            type: "text",
            style: {
              "flex": "1"
            }
          }, {
            prepend: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createElementVNode("span", {
              class: "iconfont icon-code",
              style: {
                "margin-right": "0px"
              }
            }, null, -1)]))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_button, {
            disabled: $data.countdown > 0,
            onClick: $options.sendVerificationCode,
            style: {
              "margin-left": "10px",
              "height": "40px",
              "font-size": "14px"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.countdown > 0 ? `${$data.countdown}秒后重试` : '获取验证码'), 1)]),
            _: 1
          }, 8, ["disabled", "onClick"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          loading: $data.loading,
          type: "primary",
          style: {
            "width": "50%",
            "margin-bottom": "30px"
          },
          onClick: _cache[4] || (_cache[4] = $event => $options.toSession('loginForm'))
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("登录 ", -1)]))]),
          _: 1
        }, 8, ["loading"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          type: "text",
          onClick: $options.goToRegister,
          style: {
            "text-align": "left",
            "color": "white"
          }
        }, {
          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode(" 注册账号 ", -1)]))]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          type: "text",
          onClick: $options.toggleLoginType,
          class: "toggle-btn",
          style: {
            "color": "white"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($data.loginType === 'password' ? '手机号验证码登录' : '用户名密码登录'), 1)]),
          _: 1
        }, 8, ["onClick"])]), _cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "foot"
        }, [_createElementVNode("span", {
          class: "title"
        }, "技术支持：0755 - 26649500"), _createElementVNode("span", {
          class: "title"
        }, "服务邮箱：support@callray.com.cn"), _createElementVNode("span", {
          class: "title"
        }, "公司网址：www.callray.com.cn "), _createElementVNode("span", {
          class: "title"
        }, "深圳市友邻通讯设备有限公司版权所有(C) 1997-2024")], -1))]),
        _: 1
      }, 8, ["model", "rules"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    title: "注册账号",
    modelValue: $data.registerDialogVisible,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.registerDialogVisible = $event),
    width: "40%",
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      ref: "registerForm",
      model: $data.registerForm,
      rules: $data.registerRules,
      "label-width": "80px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "用户名",
        prop: "userName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.registerForm.userName,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.registerForm.userName = $event),
          placeholder: "请输入用户名"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "姓名",
        prop: "userAlias"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.registerForm.userAlias,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.registerForm.userAlias = $event),
          placeholder: "请输入真实姓名"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "密码",
        prop: "passWord"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.registerForm.passWord,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.registerForm.passWord = $event),
          type: "password",
          placeholder: "请输入密码",
          "show-password": true
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "确认密码",
        prop: "confirmPassword"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.registerForm.confirmPassword,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.registerForm.confirmPassword = $event),
          type: "password",
          placeholder: "请确认密码",
          "show-password": true
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
        onClick: _cache[9] || (_cache[9] = $event => $data.registerDialogVisible = false)
      }, {
        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode("取消", -1)]))]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: $options.handleRegister
      }, {
        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode("注册", -1)]))]),
        _: 1
      }, 8, ["onClick"])])]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue"])]);
}